import React from "react";
import ProductList from "../components/ProductList";

const subCategoryList = [
  { id: 1, name: "Accessories" }
];

const productList = [    
    { id:1 , name: "PPEs", image: "/images/PPEs.jpg", description: "Tools.", category: "Safety Items", subCategoryId: 0 },
    { id:2 , name: "Life jacket"     , image: "/images/Lifejacket.jpg", description: "Tools.", category: "Safety Items", subCategoryId: 0 },
    { id:3 , name: "Safety Tags"     , image: "/images/SafetyTags.jpg", description: "Tools.", category: "Safety Items", subCategoryId: 0 },
    { id:4 , name: "Breath Analayser", image: "/images/BreathAnalayser.jpg", description: "Tools.", category: "Safety Items", subCategoryId: 0 },
    { id:5 , name: "Megaphone"       , image: "/images/Megaphone.jpg", description: "Tools.", category: "Safety Items", subCategoryId: 0 },
    { id:6 , name: "Insulating Mate" , image: "/images/InsulatingMate.jpg", description: "Tools.", category: "Safety Items", subCategoryId: 0 },
    
];

const SaftyItems: React.FC = () => {
  return <ProductList title="General Category Products" products={productList} subCategories={subCategoryList} categoryName="Safty Items" />;
};

export default SaftyItems;
